import React, { useState, useContext, createContext } from 'react';

const DashContext = createContext({});

export function DashProvider({ children }) {
  const [openMenu, setOpenMenu] = useState(true);
  const [isVisibleMenu, setIsVisibleMenu] = useState(true);
  const [tabAtual, setTabAtual] = useState(0);

  const handleMenu = React.useCallback(() => {
    setOpenMenu((prev) => !prev);
  }, []);

  const hiddenMenu = React.useCallback(() => {
    setIsVisibleMenu(false);
  }, []);

  const showMenu = React.useCallback(() => {
    setIsVisibleMenu(true);
  }, []);

  const changeTab = React.useCallback((tab) => {
    setTabAtual(tab);
  }, []);

  const value = React.useMemo(
    () => ({
      openMenu,
      handleMenu,
      changeTab,
      tabAtual,
      showMenu,
      hiddenMenu,
      isVisibleMenu,
    }),
    [
      openMenu,
      handleMenu,
      changeTab,
      tabAtual,
      showMenu,
      hiddenMenu,
      isVisibleMenu,
    ],
  );

  return <DashContext.Provider value={value}>{children}</DashContext.Provider>;
}

export function useDash() {
  const context = useContext(DashContext);

  if (!context) throw new Error('useDash must be used within an ToastProvider');

  return context;
}
